import React from "react";
import classNames from "classnames";
import { H2 } from "theme/components/atoms/Typography/Heading";
import Sku from "theme/components/atoms/Typography/Sku";
import { ProductPrice } from "theme/components/atoms/Typography/Price";
import ProductLabel from "theme/modules/ProductView/ProductItem/ProductLabel";
import { hasLabels } from "theme/modules/ProductView/ProductItem/ProductLabel/ProductLabel";
import ProductReviewsSynthesis from "theme/modules/Reviews/ProductReviewsSynthesis";

const ProductName = ({ product, hidePrice, hasFinalPrice }) => {
  const shouldDisplayLabels = hasLabels(product);
  return (
    <div
      className={classNames("product-name", {
        "product-name--with-labels": shouldDisplayLabels,
      })}
    >
      <div className="product-name__main">
        <div className="product-name__info">
          {!hidePrice && shouldDisplayLabels ? (
            <div className="product-name__labels">
              <ProductLabel product={product} />
            </div>
          ) : null}
          <div className="product-name__name">
            <H2 as="h1">{product.name}</H2>
            <meta itemProp="name" content={product.name} />
            <meta itemProp="sku" content={product.sku} />
          </div>
        </div>
        <div className="product-name__id">
          <Sku sku={product.sku} />
        </div>
      </div>
      {hidePrice ? null : (
        <div className="product-name__price">
          <H2 as="div">
            <ProductPrice
              prices={product.prices}
              forceFinalPrice={hasFinalPrice}
            />
          </H2>
        </div>
      )}

      {product.reviewsLayerSynthesis ? (
        <ProductReviewsSynthesis product={product} />
      ) : null}
    </div>
  );
};

export default ProductName;
